import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Field,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
  useToast,
} from "../../../design-system";
import { createEmployee } from "../../../helpers/kronaly_helper";

const initial = () => ({
  first_name: "",
  last_name: "",
  email: "",
});

const NewEmpleadoModal = ({ open, onClose, onCreated }) => {
  const toast = useToast();
  const [form, setForm] = useState(initial);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setForm(initial());
      setError(null);
    }
  }, [open]);

  const handle = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const payload = {
        first_name: form.first_name.trim(),
        last_name: form.last_name.trim(),
        email: form.email.trim(),
      };
      const r = await createEmployee(payload);
      onCreated(r?.data ?? r);
      toast.success("Empleado creado", `${form.first_name.trim()} ${form.last_name.trim()} se añadió al workspace.`);
      onClose();
    } catch (err) {
      const msg = typeof err === "string" ? err : err?.message || "No se pudo crear el empleado.";
      setError(msg);
      toast.error("No se pudo crear el empleado", msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Agregar empleado" size="md">
      <form onSubmit={onSubmit}>
        <ModalBody>
          {error && <div className="kr-mb-3"><Alert tone="danger">{error}</Alert></div>}
          <p className="kr-text-muted kr-fs-12 kr-mb-4">
            Se creará la ficha del empleado y se vinculará a tu workspace. El usuario quedará
            en estado <code>invited</code> hasta que tengamos flujo de invite por email.
          </p>
          <div className="kr-grid kr-gap-3" style={{ gridTemplateColumns: "1fr 1fr" }}>
            <Field label="Nombre" required>
              <Input
                value={form.first_name}
                onChange={handle("first_name")}
                maxLength={100}
                required
                autoFocus
              />
            </Field>
            <Field label="Apellidos" required>
              <Input
                value={form.last_name}
                onChange={handle("last_name")}
                maxLength={120}
                required
              />
            </Field>
          </div>
          <div className="kr-mt-3">
            <Field label="Email" required>
              <Input
                type="email"
                value={form.email}
                onChange={handle("email")}
                maxLength={255}
                required
                placeholder="empleado@empresa.com"
              />
            </Field>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" type="button" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving && <Spinner size={12} color="#fff" />}
            {saving ? "Creando…" : "Crear empleado"}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default NewEmpleadoModal;
